import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { BehaviorSubject } from 'rxjs';
import { IPayload } from '../models/auth.model';
import { Router } from '@angular/router';
import jwtDecode from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private _account = new BehaviorSubject<IPayload | null>(null);

  constructor(
    private storageService: StorageService,
    private router: Router,
  ) {
    const token = this.storageService.getToken();
    if (token) {
      this.decodeAndNotify(token);
    }
  }

  private notify(payload: IPayload) {
    this._account.next(payload);
  }

  private decodeAndNotify(token: string) {
    const payload = jwtDecode<IPayload>(token);
    this.notify(payload);
  }

  public saveSession(token: string, account: any) {
    this.storageService.saveToken(token, account);
    this.decodeAndNotify(token);
  }

  public logout() {
    this.storageService.deleteToken();
    this.router.navigate(['/']);
  }

  public get account() {
    return this._account.asObservable();
  }
}
